import { FENCE_PATTERN } from './promptMarkdown';

// プロンプトの変数の説明（サーバーが実際に入れる値に合わせる）。辞書に無い変数は名前だけ表示する
export const VARIABLE_INFO = {
    user_input: { label: 'ユーザーの入力文', example: '料金プランを教えて' },
    history: { label: 'これまでの会話履歴', example: 'User: … / AI: …' },
    current_time: { label: '現在日時', example: '2026-10-02 15:30:00 (金)' },
    context: { label: 'RAG で見つかった参照情報', example: '検索でヒットした資料の本文' },
    user_prompt: { label: '最終返答のユーザープロンプトの内容', example: '' },
    question: { label: 'ユーザーの質問文', example: '料金プランを教えて' },
    empathy_message: { label: '共感メッセージで作った文', example: 'ご質問ありがとうございます。' },
    lang_code: { label: '応答する言語のコード', example: 'jp / en / zh' },
};

// システムが自動で送る変数（最終返答は m_prompt 10003 / 10004 のユーザーメッセージに全変数が入っている）。
// 運営が書くと同じ内容が重複して送られるため入力アシストには出さず、「自動で送る情報」として案内する。並びは m_prompt の記載順
const AUTO_SENT_VARIABLES = {
    character: ['user_prompt', 'context', 'current_time', 'lang_code', 'question', 'empathy_message'],
};

// システムが自動で送る変数（案内表示用）
export const autoSentVariablesOf = (groupKey) => AUTO_SENT_VARIABLES[groupKey] || [];

// 入力アシストで案内する変数（テンプレートの変数から、システムが自動で送るものを除く）
export const assistVariablesOf = (groupKey, templateVariables) => {
    const autoSent = autoSentVariablesOf(groupKey);
    return (templateVariables || []).filter((v) => !autoSent.includes(v));
};

const IDENT_CHAR = /[A-Za-z0-9_]/;

/**
 * キャレットの直前が入力途中の変数（{ ＋英数字）か
 * {{（文字としての波括弧）の後ろと、コードブロックの中は対象外
 * @returns {{start: number, query: string}|null} start は { の位置
 */
export const variableQueryAt = (text, caret) => {
    let i = caret;
    while (i > 0 && IDENT_CHAR.test(text[i - 1])) i -= 1;
    const start = i - 1;
    if (start < 0 || text[start] !== '{') return null;
    // 連続する { が偶数個なら文字としての波括弧
    let braces = 0;
    for (let j = start; j >= 0 && text[j] === '{'; j -= 1) braces += 1;
    if (braces % 2 === 0) return null;
    const fences = text.slice(0, text.lastIndexOf('\n', start) + 1).split('\n').filter((ln) => FENCE_PATTERN.test(ln)).length;
    if (fences % 2 === 1) return null;
    return { start, query: text.slice(i, caret) };
};

// 前方一致 → 部分一致の順に並べる（大文字小文字は区別しない）
export const filterVariables = (names, query) => {
    const q = (query || '').toLowerCase();
    const list = names || [];
    const prefix = list.filter((n) => n.toLowerCase().startsWith(q));
    const partial = list.filter((n) => !n.toLowerCase().startsWith(q) && n.toLowerCase().includes(q));
    return prefix.concat(partial);
};

/**
 * from..to を {name} に置き換える
 * 入力途中の変数（from が {）を確定するときは、後ろに残った英数字と } も取り込んで二重にしない
 * @returns {{text, selStart, selEnd}} キャレットは } の後ろ
 */
export const insertVariable = (text, from, to, name) => {
    let end = to;
    if (text[from] === '{') {
        while (end < text.length && IDENT_CHAR.test(text[end])) end += 1;
        if (text[end] === '}') end += 1;
    }
    const token = '{' + name + '}';
    const pos = from + token.length;
    return { text: text.slice(0, from) + token + text.slice(end), selStart: pos, selEnd: pos };
};
